import { validateTextWithHypen } from '@/utils';
const getters = {
    isDialogOpen: ({ dialogDetail }) => !!dialogDetail.workerName,
    formattedWorkerName: ({ dialogDetail }) => validateTextWithHypen(dialogDetail.workerName),
};
export default getters;
